const { trackGtm, trackGtm4 } = require('util/functions');

module.exports = {
	init() {
		window.metaTags = document.getElementsByTagName('meta');
		window.postUrl = encodeURI(document.location.href);

		for (let i = 0; i < window.metaTags.length; i++) {
			const metaTag = window.metaTags[i];
			const property = metaTag.getAttribute('property');
			const content = metaTag.getAttribute('content');

			if (property === 'og:title') window.pageTitle = encodeURI(content || '');

			if (property === 'og:description')
				window.pageDescription = encodeURI(content || '');

			if (property === 'og:image') window.imageUrl = encodeURI(content || '');

			if (property === 'og:url') window.pageUrl = encodeURI(content || '');
		}

		const facebookBtns = document.querySelectorAll('.facebook-btn');
		const twitterBtns = document.querySelectorAll('.twitter-btn');
		const linkedinBtns = document.querySelectorAll('.linkedin-btn');
		const mailToBtns = document.querySelectorAll('.mailto-btn');

		facebookBtns.forEach(fb =>
			fb.setAttribute(
				'href',
				`https://www.facebook.com/sharer.php?u=${window.postUrl}`,
			),
		);
		twitterBtns.forEach(tw =>
			tw.setAttribute(
				'href',
				`https://twitter.com/share?url=${window.postUrl}&text=${window.pageTitle}`,
			),
		);
		linkedinBtns.forEach(lkn =>
			lkn.setAttribute(
				'href',
				`https://www.linkedin.com/shareArticle?url=${window.postUrl}&title=${window.pageTitle}`,
			),
		);
		mailToBtns.forEach(mb =>
			mb.setAttribute(
				'href',
				`mailto:?subject=Take a look at this on PMI.com - ${window.pageTitle}&body=I found this on PMI.com and thought that it might interest you. ${window.pageDescription}%0D%0A%0D%0A${window.pageUrl}`,
			),
		);

		this.shareList = this.root.querySelectorAll('.addthis_share_button');
		this.mail = this.root.querySelector('.mail');
		this.copyListElement = this.root.querySelector('.copyLink');
		this.currentPageProtocolAndHostName = `${window.location.protocol}//${window.location.hostname}`;
		if (this.copyListElement) {
			this.copyButton = this.copyListElement.querySelector('button');
			this.copyInput = this.copyListElement.querySelector('input');
			this.copyText = this.copyListElement.querySelector('p');
			this.copyInput.value = `${this.currentPageProtocolAndHostName}${this.copyInput.value}`;
		}

		this.initEvents();
	},
	initEvents() {
		this.gtmEvents();
	},
	gtmEvents() {
		if (this.copyListElement) {
			this.copyButton.addEventListener('click', async e => {
				const changeCopyText = () => {
					this.copyText.innerHTML = this.copyText.dataset.copied;
				};
				if (navigator.clipboard) {
					await navigator.clipboard
						.writeText(this.copyInput.value)
						.then(() => {
							changeCopyText();
						})
						.catch(err => {
							console.error(err);
						});
				} else {
					// Fallback for ie, edge
					this.copyInput.select();
					document.execCommand('copy');
					changeCopyText();
				}
				this.gtmTracking('copy', e.target);
			});
		}
		this.shareList.forEach(element => {
			// Injecting url prefix, because there won't be any more use of addthis' auto url take
			// and following the same steps as copyInput is necessary
			element.dataset.url = `${this.currentPageProtocolAndHostName}${element.dataset.url}`;
			element.addEventListener('click', () =>
				this.gtmTracking(element.dataset.service, element),
			);
			element.addEventListener('mousedown', event => {
				if (event.which === 2) {
					// Middle click logic here
					return this.gtmTracking(element.dataset.service, element);
				}
			});
		});
		this.mail.addEventListener('click', e =>
			this.gtmTracking('email', e.target),
		);
		this.mail.addEventListener('mousedown', e => {
			if (e.which === 2) {
				// Middle click logic here
				return this.gtmTracking('email', e.target);
			}
		});
	},
	gtmTracking(eventLabel, element) {
		const href = element.dataset.copylink
			? `${this.currentPageProtocolAndHostName}${element.dataset.copylink}`
			: element?.href;

		trackGtm4({
			event: 'GA4_event_c_share',
			link_text: element?.innerHTML.replace(/(<([^>]+)>)/gi, ''),
			link_url: href,
			method: eventLabel,
			widget_name: 'V3-Social Share',
		});
		trackGtm({
			eventCategory: 'share content',
			eventAction: 'share',
			eventLabel: eventLabel,
		});
	},
};
